import { useState } from "react"
import { useFormikContext } from "formik"
import { FloatingLabel, Form } from "react-bootstrap"
import { checkVal } from "../../../Helpers/Parsers/checkVal"
import { TextInputField } from "../TextInput/TextInputField"

export const OTHER_OPTION_VALUE = '__other__'

// Select that falls back to a free text input when "Other" is chosen.
// The form value is always the actual value (option value or typed text).
export const SelectWithOtherField = (props: {
  fieldLabel: string,
  fieldName: string,
  placeholder?: string,
  options: { value: string, text?: string }[],
  required?: boolean,
  disabled?: boolean,
}) => {
  const {
    fieldLabel,
    fieldName,
    placeholder,
    options,
    required,
    disabled,
  } = props

  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext<any>()
  const [otherSelected, setOtherSelected] = useState(false)

  const value: string = checkVal(values, fieldName) || ''
  const isKnownOption = options.some((option) => option.value === value)
  const isOther = !isKnownOption && (value !== '' || otherSelected)

  const hasError = Boolean(checkVal(touched, fieldName) && checkVal(errors, fieldName))

  return (
    <>
      <Form.Group className="mb-3">
        <FloatingLabel
          controlId={fieldName}
          label={`${fieldLabel}${required ? '*' : ''}`}>
          <Form.Select
            name={fieldName}
            disabled={disabled}
            required={required}
            value={isOther ? OTHER_OPTION_VALUE : value}
            onChange={(e: any) => {
              const selected = e.target.value
              if (selected === OTHER_OPTION_VALUE) {
                setOtherSelected(true)
                setFieldValue(fieldName, '')
                return
              }
              setOtherSelected(false)
              setFieldValue(fieldName, selected)
            }}
            onBlur={handleBlur}
            isInvalid={!isOther && hasError}
            aria-label={fieldLabel}>
            <option value={''}>{placeholder ? placeholder : '- Select -'}</option>
            {options.map((option) => (
              <option key={`${fieldName}-option-${option.value}`} value={option.value}>
                {option.text ? option.text : option.value}
              </option>
            ))}
            <option value={OTHER_OPTION_VALUE}>Other</option>
          </Form.Select>
        </FloatingLabel>
        {!isOther && (
          <Form.Control.Feedback type="invalid">
            {checkVal(errors, fieldName)}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      {isOther && (
        <TextInputField
          fieldLabel={`${fieldLabel} (Other)`}
          placeholder={`Enter ${fieldLabel}`}
          fieldName={fieldName}
          required={required}
          disabled={disabled} />
      )}
    </>
  )
}
